import React, { Component } from 'react'


import { Card, CardDeck, Col, Container, Table } from 'react-bootstrap'
import bvi from '../photo/bvi.jpg'

export default class Bvi extends Component {
    render() {
        return ( 
            


            <Container >
                <div bg="dark">
                    <h1  className="h1 ">Биков Валентин Іванович</h1>
                </div>
                <hr />
                <div className="about-teach">
                    <Col sm={7}>
                        
                        <p className="p"><b>Биков Валентин Іванович</b>  - заслужений діяч науки і техніки України, 
                        доктор технічних наук, професор, завідуючий кафедрою приладобудування (1988 - 1999 р.). 
                        Черкаського державного технологічного університету.</p>
                        <h3 className="text-center"><b>Біографія</b> </h3><hr />
                        
                        
                        <p className="p">Закінчив Криворізький гірничорудний інститут в 1960 році, де отримав кваліфікацію «гірничий 
                        інженер-електромеханік», та Дніпропетровський державний університет в 1965 році за спеціальністю «Математика».
                        </p>

                       
                        <p className="p">Працював деканом механіко-машинобудівного факультету Криворізького гірничорудного інституту (1965-1970 р.), 
                        ректором Криворізького державного педагогічного інституту (1973-1979 р.), директором Черкаського філіалу 
                        Київського політехнічного інституту (1987-1991 р.) і був обраний першим ректором Черкаського інженерно-технологічного інституту,
                        створеного на базі філіалу КПІ (1991-1998 р.). Завідувач кафедри технології машинобудування, металорізальних верстатів та
                        інструментів (1985-1988 р.). Завідувач кафедри приладобудування (1988 - 1999 р.). 
                        Завідувач кафедри безпеки життєдіяльності з 2004 р. і до теперішнього часу.</p>
                        
                    
                        <h3 className="text-center"><b> Наукова діяльність</b></h3><hr />
                    
                        <p className="p"></p>
                        <p className="p">Інтереси: тертя та змащування, динаміка гірничих і гірничо-збагачувальних
                         машин, прилади точної механіки, безпека життєдіяльності, охорона праці.</p>  
                        <p className="p">Науковий керівник 20 кандидатських дисертацій та науковий консультант 4 докторських дисертацій.</p>  
                        <p className="p">Опублікував понад 250 наукових та методичних праць, 37 авторських 
                        свідоцтв і патентів.</p>  <hr />  
                    
                    </Col>
                    <Col sm={5}>
                        
                        <CardDeck border="dark" className='m-3'>
                            <Card className="card">
                                <img
                                    
                                    src={bvi}
                                />
                                <Card.Body>
                                    <Card.Title  className="table-title"> <span ><b> БИКОВ<br />  Валентин Іванович</b></span> </Card.Title> <hr />
                                    <Table >
                                        
                                        <tr>
                                            <td className="table-col-1" > Місце роботи </td> 
                                            <td className="table-col-2"> Черкаський державний технологічний університет </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Освіта </td> 
                                            <td className="table-col-2" > 
                                                <ul>
                                                    <li>Криворізький гірничорудний інститут (1960)</li>
                                                    <li>Дніпропетровський державний університет в (1965)</li>
                                                </ul>
                                                
                                            </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Науковий ступінь</td> 
                                            <td className="table-col-2 "> доктор технічних наук </td>

                                        </tr>
                                        <tr>
                                            <td className="table-col-1 " > Наукове звання</td> 
                                            <td className="table-col-2 "> Професор </td>

                                        </tr>
                                    </Table>
                                    
                                    
                                </Card.Body>
                            </Card>
                        </CardDeck>
                        
                    </Col>
                    
                       
                </div><br />
            </Container>
        )
    }
}
 